exports = module.exports = require("../../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-correct {\n  padding: 1px 4px 1px;\n  margin-left: 4px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/@mprep/shared/lib/angular/components/question-view/choice-views/dropdown-choice-view/dropdown-question-view.scss
// module id = hRwJ
// module chunks = 3